import React from "react";
import {destinationService} from "../jwt/_services/xailing/destinationService";

export const destinationProvider = {
    getOptions,
    getItem,
};

async function getOptions() {
    try {
        const listItems = await destinationService.search(0, 1000, null);
        return listItems.data.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.code,
                    label: <div><label>{item.code + ' - ' + item.name}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getItem(id) {
    try {
        const item = await destinationService.getItem(id);

        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}